import { AbstractAjaxLoader, AjaxLoaderOptions } from "./AbstractAjaxLoader.js";
import { registerLoader } from "./AbstractLoader.js";

export interface ArrayBufferLoaderOptions extends AjaxLoaderOptions {

}

export class ArrayBufferLoader extends AbstractAjaxLoader<ArrayBuffer, ArrayBufferLoaderOptions>{
    protected defaultOptions(): ArrayBufferLoaderOptions {
        return {
            decoder: "arraybuffer"
        }
    }
}

registerLoader("arraybuffer", ArrayBufferLoader);